import { render } from "./company-register.vue?vue&type=template&id=716077de&scoped=true"
import script from "./company-register.vue?vue&type=script&lang=js"
export * from "./company-register.vue?vue&type=script&lang=js"

import "./company-register.vue?vue&type=style&index=0&id=716077de&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716077de"]])

export default __exports__